export default 'event:brand-deleted';

export type BrandDeletedEventParameters = {
    brandId: string,
};
